import { FC, useCallback } from 'react'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { GalleryButton, GalleryButtonWrapper, GalleryHeaderWrapper, StyledCloseIcon } from './styles'
import { Typography } from 'react-components'
import EnquiryButton from '../enquiry-button'
import BookNowButton from '../book-now-button'
import BindingInquiryButton from '../binding-inquiry-button'
import { SearchbarFieldsReturn, UpdateSearchBarTransport } from '../hooks/use-searchbar'
import isInquiryButtonVisible from '../side-bar/utils/is-inquiry-button-visible'
import isDirectBookingButtonVisible from '../side-bar/utils/is-direct-booking-button-visible'
import is24HourBookingButtonVisible from '../side-bar/utils/is-24-hour-booking-button-visible'
import CheckAvailabilityButton from '../check-availability'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'
import InquiryContactDetailsTransport from '../../../transports/inquiry-contact-details-transport'
import UserDetailsModel from '../../../models/user/user-details-model'
import { PdpToCheckoutPosition } from '../constants'
import isCheckAvailabilityButtonVisible from '../side-bar/utils/is-check-availability-button-visible'
import { usePropertyDetailsContext } from '../../../hooks/property-details'

interface GalleryHeaderProps {
    bookingType: FormattedBookingTypeData | null
    propertyName: string
    searchbar: SearchbarFieldsReturn
    onClose: () => void
    pricingDetails: FormattedLivePricingDataTransport | null
    inquiryContactDetails: InquiryContactDetailsTransport | null
    isPricingLoading: boolean
    isAvailabilityLoading: boolean
    pricingErrorCode: number | null
    updateSearchbar: UpdateSearchBarTransport
    availableDates: Date[] | null
    userDetails: UserDetailsModel | null
    petsAllowed: boolean
    onSelectDatesButtonClick: () => void
}

const GalleryHeader: FC<GalleryHeaderProps> = ({
    bookingType,
    propertyName,
    searchbar,
    onClose,
    onSelectDatesButtonClick,
    ...restProps
}) => {
    const onCheckAvailabilityClick = useCallback(() => {
        onClose()
        onSelectDatesButtonClick()
    }, [onClose, onSelectDatesButtonClick])

    const { isComboListing } = usePropertyDetailsContext()

    return (
        <GalleryHeaderWrapper>
            <Typography variant="subtitle1" fontWeight="semiBold">
                {propertyName}
            </Typography>
            <GalleryButtonWrapper>
                {isCheckAvailabilityButtonVisible(isComboListing, bookingType, searchbar) ? (
                    <GalleryButton>
                        <CheckAvailabilityButton
                            onClick={onCheckAvailabilityClick}
                            position={PdpToCheckoutPosition.GALLERY}
                        />
                    </GalleryButton>
                ) : (
                    <>
                        {isInquiryButtonVisible({ bookingType }) && (
                            <GalleryButton>
                                <EnquiryButton
                                    bookingType={bookingType}
                                    searchbar={searchbar}
                                    position={PdpToCheckoutPosition.GALLERY}
                                    {...restProps}
                                    showShortTitle
                                />
                            </GalleryButton>
                        )}
                        {isDirectBookingButtonVisible({ bookingType }) && (
                            <GalleryButton>
                                <BookNowButton
                                    bookingType={bookingType}
                                    searchbar={searchbar}
                                    position={PdpToCheckoutPosition.GALLERY}
                                    showShortTitle
                                />
                            </GalleryButton>
                        )}
                        {is24HourBookingButtonVisible({ bookingType }) && (
                            <GalleryButton>
                                <BindingInquiryButton
                                    bookingType={bookingType}
                                    searchbar={searchbar}
                                    position={PdpToCheckoutPosition.GALLERY}
                                    showShortTitle
                                />
                            </GalleryButton>
                        )}
                    </>
                )}
            </GalleryButtonWrapper>
            <GalleryButton onClick={onClose}>
                <StyledCloseIcon />
            </GalleryButton>
        </GalleryHeaderWrapper>
    )
}

export default GalleryHeader
